import {
  theme
} from "./chunk-GUZBX522.js";
import {
  mergeTheme
} from "./chunk-5DV345YV.js";
import {
  parseObject
} from "./chunk-L3VNOE5J.js";

// src/context/index.tsx
import * as React from "react";
import merge from "deepmerge";
import { jsx } from "react/jsx-runtime";
var MaterialTailwindThemeContext = React.createContext(theme);
MaterialTailwindThemeContext.displayName = "MaterialTailwind.ThemeProvider";
function ThemeProvider({
  value,
  children
}) {
  const mainTheme = parseObject(theme);
  const providedTheme = parseObject(value);
  const combinedTheme = merge(mainTheme, providedTheme);
  const mergedTheme = mergeTheme(combinedTheme);
  return /* @__PURE__ */ jsx(MaterialTailwindThemeContext.Provider, { value: mergedTheme, children });
}
function useTheme() {
  const context = React.useContext(MaterialTailwindThemeContext);
  if (!context) {
    return null;
  }
  return context;
}

export {
  MaterialTailwindThemeContext,
  ThemeProvider,
  useTheme
};
